export const SERVICE_WORKER_FILE_NAME = 'mockServiceWorker.js';
